import { render, staticRenderFns } from "./Step-2.vue?vue&type=template&id=0662a01c&scoped=true&lang=pug&"
import script from "./Step-2.vue?vue&type=script&lang=js&"
export * from "./Step-2.vue?vue&type=script&lang=js&"
import style0 from "./Step-2.vue?vue&type=style&index=0&id=0662a01c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0662a01c",
  null
  
)

export default component.exports